<nav class="bg-white shadow border-t-4 border-orange-forbes">
  <div class="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
    <div class="relative flex justify-between items-center h-16">
      <div
        class="
          flex-1 flex
          items-center
          justify-center
          sm:items-stretch sm:justify-start
        "
      >
        <div class="flex-shrink-0 flex items-center pt-5">
          <img
            (click)="logoutAndExitEac()"
            class="cursor-pointer lg:block h-12 w-auto"
            src="../../../assets/images/Logo-AFBR.svg"
            alt="Alexander Forbes Logo"
          />
        </div>
      </div>
      <button
        *ngIf="showLogout"
        (click)="logout()"
        class="
          uppercase
          bg-orange-forbes
          p-2
          font-light
          text-xs
          rounded-md
          text-white
          h-1/2
        "
      >
        Logout
      </button>
    </div>
  </div>
  <div class="px-28 py-3">
    <div class="flex justify-between">
      <div></div>
      <div class="row popia-box-shadow">
        <span>
          <img
            src="../../../assets/images/info-icon.png"
            alt="Privacy info icon"
            width="23"
            class="mr-2 pt-2px"
          />
        </span>
        <span>
          <a
            href="{{ popIaDisclosureLink }}"
            target="blank"
            class="text-orange-forbes font-semibold"
            >Find out</a
          >
          how we protect your personal information, privacy and security.
        </span>
      </div>
    </div>
  </div>
</nav>
